/**
 * Created by fers on 25.03.16.
 */

/*eslint no-console: 0 */
import raven from 'raven-js';
import React from 'react';
import config from '../../common/config';
import {Modal, Button} from 'react-bootstrap';
import ReactDOM from 'react-dom';
import './errorDisplayer.scss';
import {FormattedMessage, IntlProvider} from 'react-intl';
import nl2br from 'react-nl2br';
import {lastPanelController} from '../view/EmbededPanelController';
import deferred from '../fw/deferred';

if (config.isProduction) {
    raven.config('https://e88240f06e6e426cb8e24e37dc23492a@app.getsentry.com/95001', {
        release: config.VERSION,
        tags: {
            module: "frontend",
            stage: config.STAGE,
        }
    }).install();
}

// have only one instance of error dialog
let errorIntance = null;
const minErrorHeight = 250;
export class ErrorModal extends React.Component {
    static show(message) {
        if (errorIntance) {
            return errorIntance.showError(message);
        }

        let defer = new deferred();
        try {
            ReactDOM.render(
                <ErrorModal></ErrorModal>,
                document.createElement('div'), // doesn't need real div in dom
                () => {
                    errorIntance.showError(message).then(() => {
                        defer.resolve();
                    }).catch((e) => {
                        defer.reject(e);
                    });
                }
            );
        } catch (e) {
            /* sometime we had error showing this dialog - do not mask real error with this one */
            console.error(e);
            defer.reject(e);
        }
        return defer.promise;
    }

    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            text: ''
        };

        errorIntance = this; // eslint-disable-line consistent-this

        this.originalHeight = 0;
        this.defer = null;
    }

    componentWillUnmount() {
        errorIntance = null;
    }

    close() {
        this.setState({
            showModal: false,
            text: ''
        });

        if (this.originalHeight !== 0) {
            lastPanelController().resizeY(this.originalHeight);
            this.originalHeight = 0;
        }
        this.defer.resolve();
    }

    showError(message) {
        this.setState({
            showModal: true,
            text: message
        });

        if (window.innerHeight < minErrorHeight) {
            this.originalHeight = window.innerHeight;

            lastPanelController().resizeY(minErrorHeight);
        }
        this.defer = new deferred();

        return this.defer.promise;
    }

    render() {
        /* we are using require instead of classic 'import' - this code must be able to run on server-side and import locales.po is not supported */
        let locales = require('../locales');
        let getMessagesDefault = require('../getMessages');
        let {getLocale} = locales;
        let {getMessages} = getMessagesDefault;

        return (
            <IntlProvider locale={getLocale()} messages={getMessages()}>
                <Modal className="ErrorModal" onHide={() => this.close()} show={this.state.showModal}>
                    <Modal.Header>
                        <Modal.Title><i className="fa fa-exclamation-circle"></i> <FormattedMessage defaultMessage="Error" id="ErrorModal.title" /></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{nl2br(this.state.text)}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle="danger" onClick={() => this.close()}><FormattedMessage defaultMessage="Close" id="ErrorModal.button" /></Button>
                    </Modal.Footer>
                </Modal>
            </IntlProvider>
        );
    }
}

export function displayError(message, doSendError = true) {
    let returnPromise;

    if (typeof message === "string") {
        returnPromise = ErrorModal.show(message);

        /* convert string to Exception so raven.captureException will understand it */
        message = new Error(message);
    }

    if (doSendError) {
        console.error(message);

        if (raven && config.isProduction) {
            try {
                raven.captureException(message);
                raven.showReportDialog();
            } catch (e) {
                /* ignore error sending error */
            }
        }
    }

    if (!returnPromise) {
        returnPromise = Promise.resolve();
    }
    return returnPromise;
}

export function sendError(error, silent) {
    console.error(error);

    if (raven && config.isProduction) {
        try {
            raven.captureException(error);

            if (!silent) {
                raven.showReportDialog();
            }
        } catch (e) {
            /* ignore error sending error */
        }
    } else if (error.message) {
        ErrorModal.show("Internal error: \n\n" + error.message);
    } else {
        ErrorModal.show("Internal error");
    }
}

export function setErrorUserContext(user) {
    if (user && raven && config.isProduction) {
        raven.setUserContext({
            email: user.email,
            id: user.user_id
        });
    }
}
